/**
 * Детерминированный PRNG (Pseudo-Random Number Generator).
 *
 * Используется для live amount animation — при одинаковом seed (round_id)
 * генерируется одинаковая последовательность чисел на клиенте и сервере.
 * Python-зеркало находится в backend (если есть).
 */

/**
 * xmur3 — простой хэш-функция для создания seed из строки.
 * Возвращает функцию, которая при каждом вызове даёт следующее 32-битное число.
 */
export function xmur3(str: string): () => number {
  let h = 1779033703 ^ str.length
  for (let i = 0; i < str.length; i += 1) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353)
    h = (h << 13) | (h >>> 19)
  }
  return () => {
    h = Math.imul(h ^ (h >>> 16), 2246822507)
    h = Math.imul(h ^ (h >>> 13), 3266489909)
    return (h ^= h >>> 16) >>> 0
  }
}

/**
 * mulberry32 — быстрый детерминированный генератор в диапазоне [0, 1).
 * Совместим с Python версией из backend.
 */
export function mulberry32(seed: number): () => number {
  let state = seed >>> 0
  return () => {
    state = (state + 0x6d2b79f5) >>> 0
    let t = state
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
